import { render, staticRenderFns } from "./LanguageSelectInputWidget.vue?vue&type=template&id=17a04788&scoped=true"
import script from "./LanguageSelectInputWidget.vue?vue&type=script&lang=js"
export * from "./LanguageSelectInputWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a04788",
  null
  
)

export default component.exports